import { useMemo, useState } from 'react';
import { IUser } from '../../utils/store/model/store.model';
import { PersonalDataContext } from './PersonalDataContext';

const PersonalDataProvider = ({ children }: { children: React.ReactNode }) => {
    const [personalData, setPersonalData] = useState<IUser>({
        id: '',
        partyId: '',
        fiscalId: '',
        fiscalIdType: '',
        name: '',
        lastname1: '',
        lastname2: '',
        address: '',
        email: {
            value: '',
            verified: false,
        },
        contactNumber: {
            value: '',
            verified: false,
        },
    });

    const value = useMemo(
        () => ({
            personalData,
            setPersonalData,
        }),
        [personalData],
    );

    return <PersonalDataContext.Provider value={value}>{children}</PersonalDataContext.Provider>;
};

export default PersonalDataProvider;
